import * as THREE from "three";
import {
  POINT_LIGHT_COLOR_DEFAULT,
  POINT_LIGHT_INTENSITY_DEFAULT,
  POINT_LIGHT_DISTANCE_DEFAULT,
  POINT_LIGHT_DECAY_DEFAULT,
  POINT_LIGHT_POSITION_X_DEFAULT,
  POINT_LIGHT_POSITION_Y_DEFAULT,
  POINT_LIGHT_POSITION_Z_DEFAULT,
  POINT_LIGHT_IS_VISIBLE_DEFAULT,
} from "../config";

export const pointLightFactory = () => {
  const pointLight = new THREE.PointLight(
    POINT_LIGHT_COLOR_DEFAULT,
    POINT_LIGHT_INTENSITY_DEFAULT,
    POINT_LIGHT_DISTANCE_DEFAULT,
    POINT_LIGHT_DECAY_DEFAULT
  );

  pointLight.position.set(
    POINT_LIGHT_POSITION_X_DEFAULT,
    POINT_LIGHT_POSITION_Y_DEFAULT,
    POINT_LIGHT_POSITION_Z_DEFAULT
  );
  pointLight.visible = POINT_LIGHT_IS_VISIBLE_DEFAULT;

  return pointLight;
};
